import { SET_APP_DATA } from '../../../actions/app/index.tsx';
import type { Action } from '../../../actions/index.tsx';
import type { ProjectState } from './types.tsx';

const defaultState: ProjectState = { projects: [] };

const projectReducer = (state: ProjectState = defaultState, action: Action): ProjectState => {
	switch (action.type) {
		case SET_APP_DATA:
			return action.payload.entities.project ?? defaultState;
		default:
			return state;
	}
};

export default projectReducer;
